import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CoreComponent} from "../core-component/core.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {OtpData} from "../otp/data/otp-data";
import {ForgotPasswordRequestDto} from "../../../rg/types/registration.types";
import {CoreApiService} from "../../service/core-api.service";
import {error} from "@angular/compiler-cli/src/transformers/util";


@Component({
  selector: 'forget-password-otp',
  templateUrl: './forget-password-otp.component.html',
  styleUrls: ['./forget-password-otp.component.css']
})
export class ForgetPasswordOtpComponent extends CoreComponent {

  @Input() formGroup: FormGroup | undefined;
  @Output() onStepComplete = new EventEmitter<number>;


  constructor(protected formBuilder: FormBuilder,
              protected router: Router,
              protected registrationService: RegistrationApiService,
              protected coreApiService: CoreApiService,
              protected signUpService: SignUpService,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  handleConfirmOtp(event: OtpData) {
    const userText = this.formGroup?.get('anyUserText')?.value;
    const dto: ForgotPasswordRequestDto = {
      deviceInfo: this.coreApiService.getDeviceInfo(),
      otpCode: event.otp,
      anyUserText: userText
    }
    this.registrationService.checkForgotPasswordOtp(dto).subscribe(res => {
      this.formGroup?.patchValue({
        otp: event.otp
      })
      this.handleStepComplete();

    }, error => {

      if (event.onError) {
        event.onError(error.error.data);
      }

    })
  }

  handleRequestOtp(event: OtpData) {
    const dto: ForgotPasswordRequestDto = {
      anyUserText: event.anyUserText,
      deviceInfo: this.coreApiService.getDeviceInfo(),
      selectedOption: this.signUpService.selectedOtpOption
    }

    this.registrationService.requestForgotPasswordOtp(dto).subscribe(res => {

      if (event.onSuccess) {
        event.onSuccess(res.data);
      }

    },error => {
      if (event.onError) {
        event.onError(error.error.data);
      }

    })
  }

  handleStepComplete() {
    this.onStepComplete.emit(2);
  }


}
